var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:{'v3_index_view':  _vm.$vuetify.breakpoint.mdAndUp, 'pa-0': _vm.$vuetify.breakpoint.smAndDown}},[_c('heading-view',{attrs:{"right-column":_vm.show_table_view}}),(_vm.show_add_view)?_c('employee-add-view'):_vm._e(),(_vm.show_table_view)?_c('employee-table-view'):_vm._e(),_c('user-roles-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }